import { camelizeKeys } from 'humps';
import api from './api';
import * as docPartnerApi from 'features/document/edit/partners/api';
import * as actionTypes from './actionTypes';
import * as eventTypes from './eventTypes';
import { sendHttpRequest, sendHttpCommandAndWaitForEvent } from 'actions/actionCreators/httpActions';
import { showError } from 'actions/actionCreators/snackbarActions';

export function loadPartnersList(search) {
  //no redux cache
  return () => api.getPartnersList(search);
}

export function loadPartnerDetails(uniqueID) {
  return async dispatch => {
    dispatch({ type: actionTypes.LOAD_PARTNER_DETAILS_STARTED, key: uniqueID });

    try {
      const response = await dispatch(sendHttpRequest(api.getPartnerDetails(uniqueID)));
      dispatch({
        type: actionTypes.LOAD_PARTNER_DETAILS_SUCCEEDED,
        key: uniqueID,
        ...response
      });
      return response;
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_PARTNER_DETAILS_FAILED, key: uniqueID, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadShareholders(partnerId, documentId, siteId) {
  return async (dispatch, getState) => {
    const shareholders = getState().currentOffer.clientShareholdersData[partnerId];
    let shouldCallApi = !shareholders || (!shareholders.loaded && !shareholders.loading);

    if (!shouldCallApi) {
      return;
    }

    dispatch({ type: actionTypes.LOAD_SHAREHOLDERS_STARTED, key: partnerId });

    try {
      const response = await dispatch(sendHttpRequest(docPartnerApi.getShareholders(partnerId, documentId, siteId)));
      const result = camelizeKeys(response);
      dispatch({
        type: actionTypes.LOAD_SHAREHOLDERS_SUCCEEDED,
        key: partnerId,
        shareholders: result
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_SHAREHOLDERS_FAILED, key: partnerId, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadShareholdersSummary(documentId, siteId, partnerId) {
  return async dispatch => {
    try {
      const response = await dispatch(sendHttpRequest(docPartnerApi.getShareholdersSummary(partnerId, documentId, siteId)));
      const result = camelizeKeys(response);
      dispatch({
        type: actionTypes.LOAD_SHAREHOLDERS_SUMMARY_SUCCEEDED,
        key: partnerId,
        summary: result
      });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function saveShareholders(documentId, siteId, partnerId, shareholders) {
  return async dispatch => {
    dispatch({
      type: actionTypes.UPDATE_SHAREHOLDERS_STARTED,
      payload: shareholders,
      partnerId: partnerId
    });
    let event = await dispatch(
      sendHttpCommandAndWaitForEvent(docPartnerApi.saveShareholders(documentId, siteId, partnerId, shareholders), 'saveShareholders', [
        eventTypes.SHAREHOLDERS_UPDATED
      ])
    );
    if (event.ok) {
      dispatch({
        type: actionTypes.UPDATE_SHAREHOLDERS_SUCCEEDED,
        shareholders: event.eventBody.shareholders,
        key: partnerId
      });
    } else {
      dispatch({
        type: actionTypes.UPDATE_SHAREHOLDERS_FAILED,
        payload: { shareholders, error: event },
        key: partnerId
      });
    }
  };
}
